import services from "@/services/users";
import apiService from "@/services/systemConfiguration";
import flexService from "@/services/flex";
import { Reports } from "@inctec/elearning-ui-client";

import {
  stateInitial,
  stateLoading,
  stateLoaded,
  stateError,
} from "./loadingStates";

export default {
  state: {
    userStatePage: 0,
    userStatePages: 0,
    userStateTotal: 0,
    userStates: [],
    userStatesLoadingState: stateInitial,
    userStateDetail: null,
    userStateDetailLoadingState: stateInitial,
    // This are lists of user ids where a request to edit access respective hasCard is currently active
    userAccessLoading: [],
    userhasCardLoading: [],
    loggingConfig: {
      all: true,
    },
    apisLoadingState: stateInitial,
    apiKeysLoadingState: stateInitial,
    sessionsByUser: [],
    sessionsByUserLoadingState: stateInitial,
    currentUserStateUserId: null,
    sessionsByCourse: [],
    sessionsByCourseLoadingState: stateInitial,
    currentCourseEditCourseId: null,
  },
  mutations: {
    resetAdminState(state) {
      state.userStatePage = 0;
      state.userStatePages = 0;
      state.userStateTotal = 0;
      state.userStates = [];
      state.userStatesLoadingState = stateInitial;
      state.userStateDetail = null;
      state.userStateDetailLoadingState = stateInitial;
      state.userAccessLoading = [];
      state.userhasCardLoading = [];
      state.loggingConfig = { all: true };
      state.apisLoadingState = stateInitial;
      state.apiKeysLoadingState = stateInitial;
      state.sessionsByUser = [];
      state.sessionsByUserLoadingState = stateInitial;
      state.currentUserStateUserId = null;
      state.sessionsByCourse = [];
      state.sessionsByCourseLoadingState = stateInitial;
      state.currentCourseEditCourseId = null;
    },
    setCurrentUserStateUserId(state, payload) {
      state.currentUserStateUserId = payload;
      state.sessionsByUserLoadingState = { ...stateLoading };
    },
    setCurrentCourseEditCourseId(state, payload) {
      state.currentCourseEditCourseId = payload;
    },
    apisLoading(state) {
      state.apisLoadingState = stateLoading;
    },
    apisLoaded(state, result) {
      state.apisLoadingState = { ...stateLoaded, result };
    },
    apisError(state) {
      state.apisLoadingState = stateError;
    },
    apiKeysLoading(state) {
      state.apiKeysLoadingState = stateLoading;
    },
    apiKeysLoaded(state, result) {
      state.apiKeysLoadingState = { ...stateLoaded, result };
    },
    apiKeysError(state) {
      state.apiKeysLoadingState = stateError;
    },

    apiKeysRemove(state, id) {
      const index = state.apiKeysLoadingState.result.findIndex(
        (item) => id === item.id,
      );
      state.apiKeysLoadingState.result.splice(index, 1);
    },

    apiKeyCreated(state, key) {
      state.apiKeysLoadingState.result.push(key);
    },
    apiKeyUpdated(state, key) {
      const index = state.apiKeysLoadingState.result.findIndex(
        (item) => key.id === item.id,
      );
      state.apiKeysLoadingState.result.splice(index, 1, key);
    },

    loadingUserStates(state, payload) {
      state.userStatesLoadingState = stateLoading;
    },
    errorLoadingUserStates(state, payload) {
      state.userStatesLoadingState = { ...stateError, errorMessage: payload };
    },
    loadedUserStates(state, payload) {
      state.userStatesLoadingState = stateLoaded;
    },

    initUserStates(state, payload) {
      state.userStates = payload.result;
      state.userStatePages = payload.pagesTotal;
      state.userStatePage = payload.page;
      state.userStateTotal = payload.total;
      state.userStatesLoadingState = stateLoaded;
    },

    loadingUserStateDetail(state, payload) {
      state.userStateDetailLoadingState = stateLoading;
    },
    errorLoadingUserStateDetail(state, payload) {
      state.userStateDetailLoadingState = {
        ...stateError,
        errorMessage: payload,
      };
    },
    loadedUserStateDetail(state, payload) {
      state.userStateDetailLoadingState = stateLoaded;
    },

    initUserStateDetail(state, payload) {
      state.userStateDetail = payload;
      state.userStateDetailLoadingState = stateLoaded;
    },

    accessLoading(state, user) {
      state.userAccessLoading.push(user.id);
    },

    hasCardLoading(state, user) {
      state.userhasCardLoading.push(user.id);
    },

    covidRulesSet(state, user) {
      const userState = state.userStates.find((us) => us.id === user.id);
      if (userState) {
        userState.fulfillsCovidRules = true;
      }
    },
    userhasCardSet(state, { user, hasCard }) {
      const userState = state.userStates.find((us) => us.id === user.id);
      if (userState) {
        userState.hasCard = hasCard;
      }
      if (
        state.userStateDetail !== null &&
        state.userStateDetail.id === user.id
      ) {
        state.userStateDetail.hasCard = hasCard;
      }
      state.userhasCardLoading.splice(
        state.userhasCardLoading.findIndex((id) => id === user.id),
        1,
      );
    },

    userAccessSet(state, { user, access }) {
      const userState = state.userStates.find((us) => us.id === user.id);
      if (userState) {
        userState.access = access;
      }
      if (
        state.userStateDetail !== null &&
        state.userStateDetail.id === user.id
      ) {
        state.userStateDetail.access = access;
      }
      state.userAccessLoading.splice(
        state.userAccessLoading.findIndex((id) => id === user.id),
        1,
      );
    },

    initLoggingConfig(state, payload) {
      if (payload) {
        state.loggingConfig = payload;
      }
    },

    loadSessionsByUser(state, payload) {
      state.sessionsByUser = payload;
      state.sessionsByUserLoadingState = stateLoaded;
    },
    loadSessionsByCourse(state, payload) {
      state.sessionsByCourse = payload;
      state.sessionsByCourseLoadingState = stateLoaded;
    },
  },
  actions: {
    initLoggingConfig({ commit }) {
      const savedConfig = localStorage.getItem("loggingConfig");
      if (savedConfig) {
        const parsedConfig = JSON.parse(savedConfig);
        commit("initLoggingConfig", parsedConfig);
      }
    },
    saveLoggingConfig({ commit }, payload) {
      const strigified = JSON.stringify(payload);
      localStorage.setItem("loggingConfig", strigified);
      commit("initLoggingConfig", payload);
      commit("addNewNotification", {
        title: "success",
        text: "loggingConfigSaved",
        notificationType: "success",
      });
    },
    setAccess({ commit }, { user, access, accessFrom, accessTo, qGate }) {
      commit("accessLoading", user);
      return services
        .SET_USER_ACCESS(user.id, { access, accessFrom, accessTo, qGate })
        .then(
          (response) => {
            // TODO: Currently qGate, from/to is not being used in the state list.
            // If this is to change, the data has to be stored as well.
            commit("userAccessSet", { user, access });
          },
          (error) => {
            commit("errorLoadingUserStateDetail");
            commit("errorLoadingUserStates");
          },
        );
    },
    setHasCard({ commit }, { user, hasCard }) {
      commit("hasCardLoading", user);
      services.SET_USER_ACCESS_CARD(user.id, hasCard).then(
        (response) => {
          commit("userhasCardSet", { user, hasCard });
        },
        (error) => {
          commit("errorLoadingUserStateDetail");
          commit("errorLoadingUserStates");
        },
      );
    },

    //
    initUserStates({ commit }, { page, pageSize, ...requestBody }) {
      commit("loadingUserStates");
      Reports.searchUserstates({
        query: {
          page,
          pageSize,
        },
        body: requestBody,
      }).then(
        (response) => {
          if (!response.data) {
            commit("errorLoadingUserStates");
            return;
          }
          commit("initUserStates", { ...response.data, page });
        },
        (error) => {
          commit("errorLoadingUserStates");
        },
      );
    },
    initUserStateDetail({ commit, state }, id) {
      commit("loadingUserStateDetail");
      Reports.searchUserstates({
        query: {
          page: 1,
          pageSize: 1,
        },
        body: {
          users: [id],
          extras: true,
        },
      }).then(
        (response) => {
          commit("initUserStateDetail", response.data.result[0]);
        },
        (error) => {
          commit("errorLoadingUserStateDetail");
        },
      );
    },
    reloadUserStateDetail({ state, dispatch }) {
      if (state.userStateDetail !== null) {
        dispatch("initUserStateDetail", state.userStateDetail.id);
      }
    },

    resetPasswordById({ commit }, payload) {
      return services.RESET_PASSWORD(payload).then((data) => {
        if (data) {
          commit("addNewNotification", {
            title: "success",
            text: "passwordChanged",
            notificationType: "success",
          });
        }
      });
    },
    async loadApiKeys({ commit }) {
      commit("apiKeysLoading");
      await apiService.getApiKeys().then(
        (response) => {
          commit("apiKeysLoaded", response.data.result);
        },
        (error) => {
          commit("apiKeysError");
        },
      );
    },
    async loadApis({ commit, getters }) {
      if (getters.getApis.loaded) {
        return;
      }
      commit("apisLoading");
      await apiService.getAvailableApis().then(
        (response) => {
          commit("apisLoaded", response.data.result);
        },
        (error) => {
          commit("apisError");
        },
      );
    },
    async removeApiKey({ commit, dispatch }, id) {
      await apiService.deleteApiKey(id).then(
        () => {
          commit("apiKeysRemove", id);
        },
        (error) => {
          commit("apiKeysError");
          dispatch("loadApiKeys");
          this.$store.commit("addNewNotification", {
            title: "error",
            text: "genericError",
            notificationType: "error",
          });
        },
      );
    },

    async createApiKey({ commit, dispatch }, key) {
      return await apiService.createApiKey(key).then(
        (response) => {
          dispatch("loadApiKeys");
          return response;
        },
        (error) => {
          commit("apiKeyError");
        },
      );
    },
    async updateApiKey({ commit }, key) {
      return await apiService.updateApiKey(key.id, key).then(
        (response) => {
          commit("apiKeyUpdated", key);
          return response;
        },
        (error) => {
          commit("apiKeyError");
        },
      );
    },
    loadSessionsByUser({ commit }, userId) {
      commit("setCurrentUserStateUserId", userId);
      flexService.getSessionByUserId({ userId }).then(
        (response) => {
          commit("loadSessionsByUser", response.data);
        },
        (error) => {
          this.sessionsByUserLoadingState = { ...stateError, error };
        },
      );
    },
    loadSessionsByCourse({ commit }, courseId) {
      commit("setCurrentCourseEditCourseId", courseId);
      flexService.getSessionByCourseId({ courseId }).then(
        (response) => {
          commit("loadSessionsByCourse", response.data);
        },
        (error) => {
          this.sessionsByCourseLoadingState = { ...stateError, error };
        },
      );
    },
    async deleteCourseSessionUpdateUserList(
      { dispatch, state, commit },
      payload,
    ) {
      await flexService.deleteUserSession(payload).then(
        (response) => {
          commit("addNewNotification", {
            title: "success",
            text: "courseSessionDeleted",
            notificationType: "success",
          });

          if (state.currentUserStateUserId !== null) {
            dispatch("loadSessionsByUser", state.currentUserStateUserId);
          }
          if (state.currentCourseEditCourseId !== null) {
            dispatch("loadSessionsByCourse", state.currentCourseEditCourseId);
          }
        },
        (error) => {
          commit("addNewNotification", {
            title: "error",
            text: error,
            notificationType: "error",
          });
        },
      );
    },
  },
  getters: {
    getLoggingConfig: (state) => state.loggingConfig,

    getUserStates: (state) => state.userStates,
    getUserStatesLoadingState: (state) => state.userStatesLoadingState,

    getUserStateDetail: (state) => state.userStateDetail,
    getUserStateDetailLoadingState: (state) =>
      state.userStateDetailLoadingState,

    getUserAccessLoading: (state) => state.userAccessLoading,
    getUserHasCardLoading: (state) => state.userhasCardLoading,

    getUserStatePages: (state) => state.userStatePages,
    getUserStateTotal: (state) => state.userStateTotal,

    getApiKeys: (state) => state.apiKeysLoadingState,
    getApis: (state) => state.apisLoadingState,

    getSessionsByUser: (state) => state.sessionsByUser,
    getSessionsByUserLoadingState: (state) => state.sessionsByUserLoadingState,
    getSessionsByCourse: (state) => state.sessionsByCourse,
    getSessionsByCourseLoadingState: (state) =>
      state.sessionsByCourseLoadingState,
  },
};
